<block-ui></block-ui>
<div class="card" [formGroup]="form">
  <div class="card-body">
    <div class="card">
      <div class="card-body">
        <fieldset class="col-12">
          <legend>Datos Generales</legend>
          <div class="card">
            <div class="card-body">
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Nacionalidad</label>
                <div class="col-sm-3">
                  <select class="form-control" formControlName="per_in_nationality" [(ngModel)]="select_nationality">
                    <option value="">SELECCIONAR</option>
                    <ng-container *ngFor="let item of parameters">
                      <option *ngIf="item.sys_in_group == 300" [ngValue]="item.sys_in_parameter">
                        {{item.sys_vc_description}}</option>
                    </ng-container>
                  </select>
                </div>
                
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Tipo Documento</label>
                <div class="col-sm-3">
                  <select class="form-control" formControlName="per_in_document_type" [(ngModel)]="select_type_document">
                    <option value="">SELECCIONAR</option>
                    <ng-container *ngFor="let item of parameters">
                      <option *ngIf="item.sys_in_group == 100" [ngValue]="item.sys_in_parameter">
                        {{item.sys_vc_description}}</option>
                    </ng-container>
                     
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Nro Documento</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" formControlName="per_vc_document_number" />
                </div>
                <div class="col-auto">
                  <button class="btn btn-badminton btn-block" (click)="getpersona()">Buscar</button>
                </div>

              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Nombres</label>
                <div class="col-sm-5">
                  <input type="text" class="form-control text-uppercase" formControlName="per_vc_first_name" />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Apellidos</label>
                <div class="col-sm-5">
                  <input type="text" class="form-control text-uppercase" formControlName="per_vc_last_name" />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Celular</label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" formControlName="per_vc_cellphone">
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Correo Electronico</label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" formControlName="per_vc_email" />
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="col-12">
          <legend>Rol y Usuario</legend>
          <div class="card">
            <div class="card-body">
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Rol</label>
                <div class="col-sm-3">
                  <select class="form-control" formControlName="rol_in_type" [(ngModel)]="select_rol_in_type">
                    <option value="">SELECCIONAR</option>
                    <ng-container *ngFor="let item of parameters">
                      <option *ngIf="item.sys_in_group == 900" [ngValue]="item.sys_in_parameter">
                        {{item.sys_vc_description}}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Usuario</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" formControlName="usu_vc_login" />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Contraseña</label>
                <div class="col-sm-5">
                  <input type="password" class="form-control" formControlName="usu_tx_password" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-2">
                  <button class="btn btn-badminton btn-block" (click)="guardar()">Guardar</button>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</div>